import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import currencyFormatter from 'currency-formatter';
import { Icon, Label } from 'semantic-ui-react';
import styles from './PaymentPlan.scss';
import {
  FloatingLabelInput as Input,
} from '../../../Elements';
import NumberFormat from 'react-number-format';

export default class PaymentPlanItems extends React.Component {

  static propTypes = {
    onIPPlanItemChange: PropTypes.func.isRequired,
    DateInput: PropTypes.func,
    localInvoice: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    submitted: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.addIPPlanItem = this.addIPPlanItem.bind(this);
    this.onIPPlanItemCurrencyChange = this.onIPPlanItemCurrencyChange.bind(
      this
    );
    this.deleteIPPlanItem = this.deleteIPPlanItem.bind(this);
    this.generateId = this.generateId.bind(this);
  }

  onIPPlanItemCurrencyChange(e, idx) {
    const localInvoice = _.cloneDeep(this.props.localInvoice);
    localInvoice.i_pplan_items.edges[idx].node[e.target.name] = Math.round(
      e.target.value * 100
    );
    this.props.onChange(localInvoice);
  }

  addIPPlanItem() {
    const localInvoice = _.cloneDeep(this.props.localInvoice);
    localInvoice.i_pplan_items.edges.push({
      node: {
        amount_cents: null,
        amount_currency: 'USD',
        due_at: null,
        locked: false,
        percent: null,
        tempId: this.generateId()
      }
    });
    this.props.onChange(localInvoice);
  }

  deleteIPPlanItem(idx) {
    const localInvoice = _.cloneDeep(this.props.localInvoice);
    const existingIPPlanId = this.props.localInvoice.i_pplan_items.edges[idx]
      .node.id;
    if (existingIPPlanId) {
      localInvoice.delete_pplan_items_with_ids = localInvoice.delete_pplan_items_with_ids
        ? localInvoice.delete_pplan_items_with_ids.push(existingIPPlanId)
        : [existingIPPlanId];
    }
    localInvoice.i_pplan_items.edges.splice(idx, 1);
    this.props.onChange(localInvoice);
  }

  generateId() {
    return `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2);
  }

  render() {
    const { localInvoice, submitted, DateInput } = this.props;
    return (
      <div>
        <p
          style={{ marginTop: '1.75em', marginBottom: '1.75em' }}
        >
          The remaining balance of{' '}
          {localInvoice.down_payment_distribution_type === 'FIXED'
            ? currencyFormatter.format(
                ((localInvoice.total_cents || 0) -
                  (localInvoice.down_payment_cents || 0)) /
                  100,
              {
                code: 'USD'
              }
              )
            : currencyFormatter.format(
                (localInvoice.total_cents || 0) *
                  (100 - localInvoice.down_payment_percent) /
                  10000,
              {
                code: 'USD'
              }
              )}{' '}
          is distributed across{' '}
          {localInvoice.i_pplan_items.edges.length} payment{localInvoice.i_pplan_items.edges.length !== 1 ? 's' : ''}
        </p>
        {localInvoice.i_pplan_items.edges.map(
          (iPPlanItem, idx) =>
            <div
              key={iPPlanItem.node.id || iPPlanItem.node.tempId}
              className={[styles.pplanItem, idx % 2 === 0 ? styles.altRow : ''].join(' ')}
            >
              {!iPPlanItem.node.locked &&
                <div
                  className={styles.delete}
                  onClick={this.deleteIPPlanItem.bind(
                    null,
                    idx
                  )}
                >
                  <Icon name='close' />
                </div>}
              {localInvoice.pplan_distribution_type ===
                'FIXED' &&
                <Input
                  name='amount_cents'
                  type='currency'
                  placeholder='$500.00'
                  value={
                    iPPlanItem.node.amount_cents
                      ? (iPPlanItem.node.amount_cents || 0) /
                        100
                      : ''
                  }
                  onChange={e =>
                    this.onIPPlanItemCurrencyChange(e, idx)}
                  submitted={submitted}
                  required
                  disabled={iPPlanItem.node.locked}
                  inline='last'
                  width='80px'
                  label=''
                  style={{
                    marginTop: '1.25em'
                  }}
                  validationError='Required'
                >
                  <NumberFormat
                    thousandSeparator
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </Input>}
              {localInvoice.pplan_distribution_type ===
                'PERCENT' &&
                <Input
                  name='percent'
                  placeholder='50%'
                  disabled={iPPlanItem.node.locked}
                  value={iPPlanItem.node.percent || ''}
                  onChange={e =>
                    this.props.onIPPlanItemChange(e, idx)}
                  submitted={submitted}
                  required
                  inline='last'
                  width='50px'
                  label=''
                  style={{
                    marginTop: '1.25em'
                  }}
                  validationError='Required'
                />}
              {localInvoice.pplan_distribution_type ===
              'PERCENT'
                ? 'percent'
                : ''}
              <div
                style={{
                  display: 'inline-block',
                  marginTop: '1.75em',
                  marginLeft: '0.5em',
                  marginRight: '0.5em'
                }}
                className={iPPlanItem.node.locked ? styles.locked : ''}
              >
                due on
              </div>
              <DateInput
                dateOnly
                value={iPPlanItem.node.due_at || ''}
                onChange={e => this.props.onIPPlanItemChange(e, idx)}
                name='due_at'
                disabled={iPPlanItem.node.locked}
                datePlaceholder='Date'
                placeholder='Date'
                label=''
                style={{
                  marginTop: '1.25em'
                }}
                inline
                required
                validationError='Required'
                submitted={submitted}
                viewer={null}
              />
              {iPPlanItem.node.status === 'paid' &&
                <div style={{ paddingBottom: '1em' }}><Label basic size='small' color='green' content='Paid' /></div>
              }
            </div>
        )}
        <p style={{ marginTop: '1em', marginBottom: '2em' }}>
          <a onClick={this.addIPPlanItem}>+ Add Payment</a>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/PaymentPlan/PaymentPlanItems.js